"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextMovieTheme = void 0;

var _themes = require("baseui/themes");

var _nextMovieTokens = require("./next-movie-tokens");

var nextMovieThemeOverrides = {
  name: 'next-movie-theme',
  colors: {
    buttonPrimaryFill: '#F9B248',
    buttonPrimaryText: '#0E2431',
    buttonPrimaryHover: '#fcaa2d',
    buttonPrimaryActive: '#faa420',
    buttonPrimarySelectedFill: '#faa420',
    buttonPrimarySelectedText: '#0E2431',
    buttonPrimarySpinnerForeground: '#fcb649',
    buttonPrimarySpinnerBackground: '#f59c14',
    background: '#0e2431',
    colorPrimary: _nextMovieTokens.colors.primary,
    colorSecondary: _nextMovieTokens.colors.secondary,
    colorTertiary: _nextMovieTokens.colors.tertiary
  }
};
var NextMovieTheme = (0, _themes.createTheme)(_themes.lightThemePrimitives, nextMovieThemeOverrides);
exports.NextMovieTheme = NextMovieTheme;